import React from 'react';

const Nigeria = () => {
  return (
    <div>
      
    </div>
  );
}

export default Nigeria;
